import { Controller } from "stimulus";

// Loads sort + pagination navigation for an index table over AJAX, replacing
// the table in place instead of triggering a full page reload. The controller
// element wraps the table; the server responds to xhr requests with just the
// table partial.
export default class extends Controller {
  connect() {
    this.onClick = this.onClick.bind(this);
    this.element.addEventListener("click", this.onClick);
  }

  disconnect() {
    this.element.removeEventListener("click", this.onClick);
  }

  onClick(event) {
    const link = event.target.closest("a");

    if (!link || !this.element.contains(link)) return;

    const isSortLink = link.closest("thead") !== null;
    const isPaginationLink = link.closest("nav.pagy-bootstrap-nav") !== null;

    if (!isSortLink && !isPaginationLink) return;

    event.preventDefault();
    this.loadContent(link.getAttribute("href"));
  }

  loadContent(url) {
    this.setSpinner();

    $.ajax({
      url: url,
      type: "GET",
      dataType: "html",
      beforeSend: (xhr) => {
        xhr.setRequestHeader(
          "X-CSRF-Token",
          localStorage.getItem("bp-x-csrf-token")
        );
      },
      success: (response) => {
        this.element.innerHTML = response;

        $('[data-toggle="tooltip"]').tooltip();
      },
      error: () => {
        window.notyf.error("Something went wrong when loading your request. Please refresh the page or try again.");
      },
    });
  }

  setSpinner() {
    this.element.innerHTML = '<h3 class="text-center p-5"><i class="fad fa-spinner-third fa-spin d-inline-block text-secondary fa-2x"></i></h3>';
  }
}
